import { startTransition, useMemo, useState } from 'react';

export type ProductDrawerRequest<TCreateSeed = never> =
  | { mode: 'edit'; productId: number }
  | { mode: 'create'; seed?: TCreateSeed };

export type ProductDrawerState<TCreateSeed = never> = {
  request: ProductDrawerRequest<TCreateSeed> | null;
  open: (request: ProductDrawerRequest<TCreateSeed>) => void;
  close: () => void;
};

/** Shared drawer request state; context wrappers interpret optional seeds. */
export function useProductDrawerState<TCreateSeed = never>(): ProductDrawerState<TCreateSeed> {
  const [request, setRequest] = useState<ProductDrawerRequest<TCreateSeed> | null>(null);

  return useMemo(
    () => ({
      request,
      open: (next: ProductDrawerRequest<TCreateSeed>) => startTransition(() => setRequest(next)),
      close: () => setRequest(null),
    }),
    [request],
  );
}
